export default {
  meta: {
    charset: "utf-8",
    siteName: "Manifold Scholarship",
    locale: "de_DE"
  }
};
